import { useSelector } from "react-redux";
import {
  LoginRoute,
  DashboardRoute,
  ContactUsRoute,
  SignUpRoute,
  InitialRoute,
  HomeRoute,
  Statement2257Route,
  PrivacyPolicyRoute,
  TermsOfServiceRoute,
  ComplaintsPolicyRoute,
  ContentRemovalPolicyRoute,
} from "../../../../core/routes/route_constants";
import { useState, useEffect } from "react";
import "./styles/animations.css";
import { useLocation, useNavigate } from "react-router-dom";

const PageV2Comp = ({ children, hideFooter = false, hideHeader = false }) => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.user);
  const location = useLocation();
  const currentPath = location.pathname;
  const isHome = currentPath === InitialRoute || currentPath === HomeRoute;
  const isDisabledScroll = false;// currentPath === LoginRoute || currentPath === SignUpRoute;
  
  return (
    <div
      className={
        "min-h-dvh flex flex-col text-white overflow-hidden relative bg-slate-950"
      }
    >
      {!hideHeader && (
        <header
          className={`top-0 left-0 w-full z-10 transition-all duration-300`}
        >
          <div className="mx-auto px-4 h-16 flex items-center justify-between">
            <div className="flex items-center">
              <i
                className="pi pi-heart text-red-700 mr-2 animate-pulse-soft"
                style={{ fontSize: "20px" }}
              ></i>
              <a href="/" className="font-serif text-xl shimmer-effect">
                ErotiX AI
              </a>
            </div>
            <div className="flex items-center space-x-6">
              {isHome && (
                <nav className="hidden md:flex items-center space-x-6">
                  <a
                    href="#features"
                    className="text-base text-pink-300 hover:text-white transition-colors"
                  >
                    Features
                  </a>
                  <a
                    href="#timeline"
                    className="text-base text-pink-300 hover:text-white transition-colors"
                  >
                    Timeline
                  </a>
                  <a
                    href="#faq"
                    className="text-base text-pink-300 hover:text-white transition-colors"
                  >
                    FAQ
                  </a>
                </nav>
              )}
              <div className="flex items-center space-x-2">
                <button
                  className="text-sm px-4 py-1.5 bg-slate-900/70 hover:bg-slate-800/80 rounded-full transition-all"
                  onClick={() => {
                    user != null
                      ? (window.location.href = DashboardRoute)
                      : (window.location.href = LoginRoute);
                  }}
                >
                  {user != null ? user?.name ?? "Login" : "Login"}
                </button>
              </div>
            </div>
          </div>
        </header>
      )}
      <div
        className={
          `page-v2-container relative z-10 overflow-x-hidden ` +
          (isDisabledScroll
            ? " md:overflow-y-hidden md:h-dv md:pb-4 overflow-y-auto h-auto min-h-dvh"
            : "")
        }
      >
        {/* Header with scroll effect */}

        <div className="bg-gradient-to-b from-slate-950 via-fuchsia-950 to-gray-950 md:min-h-dvh">
          <div className="md:mx-auto">
            <div className="">{children}</div>
          </div>
          {/* Footer */}
          {!hideFooter && (
            <footer className="w-full pt-8 border-t border-red-900/20">
              <div className="md:mx-auto max-w-6xl">
                <div className="flex flex-col md:flex-row justify-between items-center text-center gap-4 mb-8 px-4">
                  {/* Left Section */}
                  <div className="w-full flex flex-col md:text-left">
                    <div className="flex items-center justify-center md:justify-start mb-4">
                      <i
                        className="pi pi-heart text-red-700 mr-2"
                        style={{ fontSize: "18px" }}
                      ></i>
                      <span className="font-serif text-xl shimmer-effect">
                        ErotiX AI
                      </span>
                    </div>
                    <p className="text-sm text-pink-300 mb-4 text-center md:text-left">
                      Advanced AI companionship with personalized technology.
                    </p>
                    <div className="flex justify-center md:justify-start space-x-4">
                      <a
                        href="https://twitter.com/erotixai"
                        className="w-8 h-8 bg-slate-900/70 rounded-full flex items-center justify-center transition-colors hover:bg-slate-800"
                      >
                        <i
                          className="pi pi-twitter text-pink-300"
                          style={{ fontSize: "16px" }}
                        ></i>
                      </a>
                      <a
                        href="https://instagram.com/erotixai"
                        className="w-8 h-8 bg-slate-900/70 rounded-full flex items-center justify-center transition-colors hover:bg-slate-800"
                      >
                        <i
                          className="pi pi-instagram text-pink-300"
                          style={{ fontSize: "16px" }}
                        ></i>
                      </a>
                    </div>
                  </div>

                  {/* Middle Section */}
                  <div className="w-full flex flex-col md:text-left">
                    <h3 className="font-medium mb-4 text-pink-200">Company</h3>
                    <ul className="space-y-2 text-sm">
                      {/* <li>
                        <a
                          href="/about"
                          className="text-pink-300 hover:text-white transition-colors block"
                        >
                          About Us
                        </a>
                      </li> */}
                      <li>
                        <a
                          href={ContactUsRoute}
                          className="text-pink-300 hover:text-white transition-colors block"
                        >
                          Contact
                        </a>
                      </li>
                    </ul>
                  </div>

                  {/* Right Section */}
                  <div className="w-full flex flex-col md:text-left">
                    <h3 className="font-medium mb-4 text-pink-200">Legal</h3>
                    <ul className="space-y-2 text-sm flex flex-col items-center md:items-start">
                      <li className="w-full flex justify-center md:justify-start">
                        <button
                          onClick={() => navigate(PrivacyPolicyRoute)}
                          className="text-pink-300 hover:text-white transition-colors text-center md:text-left w-full"
                        >
                          Privacy Policy
                        </button>
                      </li>
                      <li className="w-full flex justify-center md:justify-start">
                        <button
                          onClick={() => navigate(TermsOfServiceRoute)}
                          className="text-pink-300 hover:text-white transition-colors text-center md:text-left w-full"
                        >
                          Terms of Service
                        </button>
                      </li>
                      <li className="w-full flex justify-center md:justify-start">
                        <button
                          onClick={() => navigate(ComplaintsPolicyRoute)}
                          className="text-pink-300 hover:text-white transition-colors text-center md:text-left w-full"
                        >
                          Complaints Policy
                        </button>
                      </li>
                      <li className="w-full flex justify-center md:justify-start">
                        <button
                          onClick={() => navigate(ContentRemovalPolicyRoute)}
                          className="text-pink-300 hover:text-white transition-colors text-center md:text-left w-full"
                        >
                          Content Removal Policy
                        </button>
                      </li>
                      <li className="w-full flex justify-center md:justify-start">
                        <button
                          onClick={() => navigate(Statement2257Route)}
                          className="text-pink-300 hover:text-white transition-colors text-center md:text-left w-full"
                        >
                          2257 Statement
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Bottom Section */}
                <div className="flex flex-col md:flex-row justify-center items-center border-t border-red-900/20 pt-6 pb-6">
                  <div className="text-sm text-pink-400/70">
                    &copy; 2025 ErotiX AI. All rights reserved.
                  </div>
                </div>
              </div>
            </footer>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageV2Comp;
